import request from '@/plugin/axios'
import { saveAs } from 'file-saver'

export function pageList(query) {
return request({
url: '/api/admin/oil/pageList',
method: 'get',
params: query
})
}

export function addObj(obj) {
return request({
url: '/api/admin/oil',
method: 'post',
data: obj
})
}

export function getObj(id) {
return request({
url: '/api/admin/oil/' + id,
method: 'get'
})
}

export function delObj(id) {
return request({
url: '/api/admin/oil/' + id,
method: 'delete'
})
}

export function putObj(id, obj) {
return request({
url: '/api/admin/oil/' + id,
method: 'put',
data: obj
})
}



export function exportCsv(types, fileName) {
    if(!types)return;
    return request({
        url: '/api/admin/oil/export/'+types,
        method: 'post',
        responseType:'blob'
    }).then((res)=>{
        let blob = new Blob([res.data],{type:""});
        saveAs(blob, fileName)
    }).catch(err=>{
        console.log(err);
    })
}
